import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { Loading } from '@rd-web-markets/shared/dist/util';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { UserService } from '@rd-web-markets/shared/dist/services/user.service';
import React, { useCallback } from 'react';
import { useState, useEffect } from 'react';
import { Col, Form, Card, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import collaboratingCompaniesService from '@services/collaborating_companies.service';
import { useErrorHandling } from '../../hooks/useErrorHandling';
const CreateAccountantCollaboratorModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit,
    claimGroup
  } = _ref;
  const [clientContact, setClientContact] = useState({
    id: null,
    roles: ['accountant']
  });
  const [users, setUsers] = useState(null);
  const [collaboratingCompanies, setCollaboratingCompanies] = useState(null);
  const [selectedCollaboratingCompany, setSelectedCollaboratingCompany] = useState(null);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const getCollaboratingCompanies = useErrorHandling(useCallback(async () => {
    const collaboratingCompanies = await collaboratingCompaniesService.all();
    setCollaboratingCompanies(collaboratingCompanies);
  }, [setCollaboratingCompanies]));
  useEffect(() => {
    getCollaboratingCompanies();
  }, []);
  useEffect(() => {
    (async () => {
      // fetch users
      try {
        const users = await UserService.all('accountant');
        setUsers(users.users);
      } catch (e) {
        dispatch(handleError(e));
      }
    })();
  }, [dispatch]);
  const handleChange = event => {
    const value = event.target.value;
    setClientContact({
      ...clientContact,
      [event.target.name]: value
    });
  };
  const handleCollaboratingCompanyChange = e => {
    setSelectedCollaboratingCompany(e.target.value);
  };
  const clientContactModalBody = () => {
    return /*#__PURE__*/React.createElement(Card, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Table, {
      className: "table-bordered"
    }, /*#__PURE__*/React.createElement("tbody", {
      "data-testid": "clientContactModalBody"
    }, /*#__PURE__*/React.createElement("tr", {
      className: "text-primary app-fs-table-header"
    }, /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, t('collaborating_company')), /*#__PURE__*/React.createElement("th", {
      className: "border-0 font-weight-normal",
      style: {
        width: '20%'
      }
    }, t('user'))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
      as: "select",
      name: "user_id",
      onChange: e => handleCollaboratingCompanyChange(e),
      size: "md"
    }, /*#__PURE__*/React.createElement("option", {
      value: null
    }), collaboratingCompanies.map(cc => {
      return /*#__PURE__*/React.createElement("option", {
        key: cc.id,
        value: cc.id
      }, cc.name);
    }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Control, {
      as: "select",
      name: "user_id",
      onChange: e => handleChange(e),
      size: "md"
    }, /*#__PURE__*/React.createElement("option", {
      value: null
    }), users.filter(user => user.company_users.some(cu => cu.company_id === claimGroup.company_id)).filter(user => user.collaborating_company_id === +selectedCollaboratingCompany).filter(user => claimGroup.user_accesses.every(access => access.user.id !== user.id)).map(u => {
      return /*#__PURE__*/React.createElement("option", {
        key: u.id,
        value: u.id
      }, u.name + ' - ' + u.email);
    }))))))));
  };
  if (!users || !collaboratingCompanies) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: t(title),
    show: show,
    renderBody: () => clientContactModalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(clientContact)
  }));
};
export default CreateAccountantCollaboratorModal;